import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SettingsCellIcon(props: IconProps) {
    return <Icon {...props} iconKey={"settings_cell"}/>
}
